// extracted by mini-css-extract-plugin
export default {"cls1":"PaperNewsStory-cls1___c7d57f0a687e58d70be","cls2":"PaperNewsStory-cls2__ee316e5111ff49ddff00 PaperNewsStory-cls1___c7d57f0a687e58d70be"};